import { Helmet } from 'react-helmet';
import { SITE_NAME, DEFAULT_DESCRIPTION } from '../seoConfig.js';

const SeoHelmet = ({
    title,
    description = DEFAULT_DESCRIPTION,
    keywords = [],
    image,
    type = 'article',
    noindex = false
}) => {
    const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const keywordContent = keywords.filter(Boolean);
    const hasKeywords = keywordContent.length > 0;
    const ogType = type || 'article';
    const hasImage = Boolean(image);

    return (
        <Helmet>
            <html lang="ja" />
            <title>{pageTitle}</title>
            {description && <meta name="description" content={description} />}
            {hasKeywords && <meta name="keywords" content={keywordContent.join(', ')} />}

            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={pageTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:type" content={ogType} />
            {hasImage && <meta property="og:image" content={image} />}

            <meta name="twitter:card" content={hasImage ? 'summary_large_image' : 'summary'} />
            <meta name="twitter:title" content={pageTitle} />
            {description && <meta name="twitter:description" content={description} />}
            {hasImage && <meta name="twitter:image" content={image} />}

            {noindex && <meta name="robots" content="noindex, nofollow" />}
        </Helmet>
    );
};

export default SeoHelmet;

